import {ApplicationRef, ComponentFactoryResolver, Injectable, Injector, NgZone} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {WafCaptchaModalComponent} from "./waf-captcha-modal.component";

@Injectable({
  providedIn: 'root'
})
export class WafCaptchaModalService {

  private modalElementRef: any;
  private readonly captchaVisibleSubject = new BehaviorSubject<boolean>(false);

  public readonly captchaVisible$: Observable<boolean> = this.captchaVisibleSubject.asObservable();

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector,
    private ngZone: NgZone
  ) {
  }

  open(content: any) {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(WafCaptchaModalComponent);
    this.modalElementRef = componentFactory.create(this.injector);

    this.appRef.attachView(this.modalElementRef.hostView);

    const domElem = (this.modalElementRef.hostView as any).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);

    if (content) {
      const modalContentElem = domElem.querySelector('.waf-captcha-popup-modal-content');
      modalContentElem?.appendChild(content);
    }

    this.setCaptchaVisible(true);
  }

  close() {
    if (!this.modalElementRef) {
      return;
    }
    this.appRef.detachView(this.modalElementRef.hostView);
    this.modalElementRef.destroy();
    this.modalElementRef = null;
    this.setCaptchaVisible(false);
  }

  private setCaptchaVisible(visible: boolean) {
    this.ngZone.run(() => this.captchaVisibleSubject.next(visible));
  }
}
